import React from 'react';
import { StyledAdColumn, AdColumnContent } from '../styles';

export const AdColumn: React.FC = props => {
  const { children, ...otherProps } = props;
  return (
    <StyledAdColumn {...otherProps}>
      <AdColumnContent>{children}</AdColumnContent>
    </StyledAdColumn>
  );
};
